import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { Notification } from '../../../../config/Global';

const { Title } = Typography;

const DeleteComponent = observer((props) => {
	const { visible, onClose } = props;

	const [saving, setSaving] = useState(false);

	const { ENQUIRY } = useStore();

	const deleteEnquiry = () => {
		setSaving(true);

		ENQUIRY.deleteEnquiry({
			id: visible.id.toString(),
			versionNo: visible.versionNo,
		})
			.then(() => {
				Notification.success({
					message: Message().CRUD.DELETE('Enquiry'),
				});

				onClose();
			})
			.catch(() => {
				Notification.error({
					message: 'Something Wrong',
				});
			})
			.finally(() => setSaving(false));
	};

	return (
		<Modal
			title="Delete Enquiry"
			onCancel={onClose}
			open={visible}
			destroyOnClose
			width={'450px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						loading={saving}
						onClick={deleteEnquiry}
					>
						Delete
					</Button>

					<Button key={2} onClick={onClose}>
						Cancel
					</Button>
				</div>
			}
		>
			<Title level={5}>
				Are you sure you want to delete
				<b>{' ' + visible?.name}</b> enquiry?
			</Title>
		</Modal>
	);
});

export default DeleteComponent;